import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import mask from '../../../../../../../utils/mask';
import { IMotoristaDetalhes } from '../../../../../../../store/ducks/agendamentos/types';
import TextTable from '../../../../../../../components/TextTable';
import { Container, Label } from './styles';
import TitlePage from '../../../../../../../components/TitlePage';

interface IMotorista {
  motorista: IMotoristaDetalhes;
}

const ModalDetalhesMotorista: React.FC<IMotorista> = ({ children, motorista }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  return (
    <>
      <Modal
        centered
        title={<TitlePage>{motorista?.nome}</TitlePage>}
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        maskClosable={true}
        closable={true}
        destroyOnClose={true}
        closeIcon={<CloseOutlined />}
        keyboard={true}
        width={750}
        footer={[
          <Button key="back" size="middle" onClick={() => setIsModalVisible(false)}>
            Fechar
          </Button>,
        ]}
      >
        <Container>
          <div>
            <p>
              <Label>Nome:</Label>
              <TextTable>
                {motorista?.nome ? mask('camelCase', motorista?.nome) : 'Não informado'}
              </TextTable>
            </p>
            <p>
              <Label>CPF:</Label>
              <TextTable>
                {motorista?.cpf ? mask('cpfCnpj', motorista?.cpf) : 'Não informado'}
              </TextTable>
            </p>
            <p>
              <Label>Telefone</Label>
              <TextTable>{motorista?.telefone ? motorista?.telefone : 'Não informado'}</TextTable>
            </p>
          </div>

          <div>
            <p>
              <Label>CNH:</Label>
              <TextTable>
                {motorista?.habilitado ? motorista?.habilitado?.toUpperCase() : 'Não informada'}
              </TextTable>
            </p>
            <p>
              <Label>MOPP:</Label>
              <TextTable>{motorista?.mopp === true ? 'Sim' : 'Não'}</TextTable>
            </p>
          </div>
        </Container>
      </Modal>
      <Button
        style={{
          padding: 0,
          whiteSpace: 'normal',
        }}
        type="link"
        onClick={() => showModal()}
      >
        {children}
      </Button>
    </>
  );
};

export default ModalDetalhesMotorista;
